/* 0.48.25 - The sign-up page's part of the bot check (backend
 * services/signup_guard.py): a token asked for when the page opens,
 * and a field people never see. A script that fills every field, or
 * sends the form at once, is refused; a person notices nothing.
 *
 * After a refused or failed attempt a new token is fetched only when
 * the one held is over 90 minutes old (tokens last two hours), so a page
 * left open for hours still works on the next try. 0.48.29 - Was: every
 * time, and a new token is refused for its first 2 seconds, so a
 * visitor who corrected a field and pressed again at once was refused
 * as a script. */
import { useCallback, useEffect, useRef, useState } from 'react';
import { authApi } from '../api/auth';

/* 0.48.29 - `active` false skips the fetch: a page with no "create
   account" rule asks for no token. */
export function useSignupGuard(active = true) {
  const token = useRef('');
  const [website, setWebsite] = useState('');
  const fetchedAt = useRef(0);
  const load = useCallback(() => {
    if (!active) return;
    authApi.signupCheck().then((r) => {
      token.current = (r && r.token) || '';
      fetchedAt.current = Date.now();
    }).catch(() => {});
  }, [active]);
  useEffect(() => { load(); }, [load]);
  const refresh = useCallback(() => {
    if (!token.current || Date.now() - fetchedAt.current > 90 * 60 * 1000) load();
  }, [load]);
  const extra = () => ({ check: token.current, website });
  /* Off screen rather than display:none (some scripts skip hidden
     fields), out of the tab order and unseen by a screen reader. */
  const field = (
    <div aria-hidden="true" style={{ position: 'absolute', left: '-10000px', top: 'auto', width: 1, height: 1, overflow: 'hidden' }}>
      <label htmlFor="signup-website">Website</label>
      <input id="signup-website" name="website" type="text" tabIndex={-1} autoComplete="off"
             value={website} onChange={(e) => setWebsite(e.target.value)} />
    </div>
  );
  return { extra, refresh, field };
}
